import {
  Polygon,
  Feature,
  Position,
  Properties,
  area,
  length,
  lineString,
} from "@turf/turf";
import { floor, isArray } from "lodash-es";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useMap } from "react-leaflet";
import { convertLatLngsToPolygon } from "utils/DrawUtils";

interface Props {}

export default function RulerLine(props: Props) {
  const map = useMap();
  const { t } = useTranslation();

  useEffect(() => {
    map.on("pm:drawstart", (e) => {
      e.workingLayer.on("pm:change", (ev) => {
        const polygonLatLngs = ev.latlngs;
        if (polygonLatLngs) {
        }
        if (!isArray(polygonLatLngs) || polygonLatLngs.length === 1) return;
        const convertedLatLngs = polygonLatLngs.map((latlng) => {
          const position: Position = [latlng.lng, latlng.lat];
          return position;
        });

        const lineStringObject = lineString(convertedLatLngs);

        const tooltipPane = map.getPanes().tooltipPane;
        // @ts-ignore
        const [firstTooltip] = tooltipPane.getElementsByClassName(
          "leaflet-tooltip-bottom"
        );
        const totalLength = floor(
          length(lineStringObject, { units: "meters" }),
          2
        ).toLocaleString("nl-BE");
        const polygon = convertLatLngsToPolygon(polygonLatLngs);

        function createDivWithId(id: string) {
          const newDiv = document.createElement("div");
          newDiv.id = id;
          return newDiv;
        }

        function updateDivContent(
          div: HTMLElement,
          length: string,
          polygon: Feature<Polygon, Properties> | undefined
        ) {
          div.innerHTML = t("label.lengthM", { length });
          if (polygon) {
            div.innerHTML += `<br>${t("label.areaSqM", {
              area: floor(area(polygon), 2).toLocaleString("nl-BE"),
            })}`;
          }
        }

        const squareMeterDiv =
          document.getElementById("squareMeterDiv") ||
          createDivWithId("squareMeterDiv");

        updateDivContent(squareMeterDiv, totalLength, polygon);

        if (!document.getElementById("squareMeterDiv")) {
          firstTooltip.appendChild(squareMeterDiv);
        }
      });
    });
    map.pm.enableDraw("Line", {
      continueDrawing: true,
      snapDistance: 10,
      templineStyle: {
        color: "green",
        dashArray: [5, 5],
      },
      hintlineStyle: {
        color: "green",
        dashArray: [5, 5],
      },
    });

    map.on("pm:create", (e) => {
      e.layer.remove();
    });

    return function () {};
  }, [map, t]);

  useEffect(() => {
    return function () {
      map.pm.disableDraw("Line");
      map.off("pm:drawstart");
      map.off("pm:create");
    };
  }, [map]);

  return null;
}
